  $( document ).ready(function() {
 var marqueeInt = setInterval(function () {
       if($('.marquee-content.slick-initialized').length){
        $('.marquee-content').removeClass('hidden')
        clearInterval(marqueeInt)
    }
},100)
});
$(".marquee-content").slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  touchMove: false,
  autoplaySpeed: 0,
  draggable: false,
  swipeToSlide: false,
  speed: 8000,
  variableWidth: true,
  pauseOnHover: false,
  cssEase: 'linear',
    responsive: [
        {
        breakpoint: 1224,
        settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 8000,
        pauseOnHover: false,
        cssEase: 'linear',
        },
      },
      {
        breakpoint: 600,
        settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        touchMove: false,
        autoplaySpeed: 0,
        speed: 6000,
        touchMove: false,  
        pauseOnHover: false,
        cssEase: 'linear',
        },
      },
      {
        breakpoint: 480,
        settings: {
        slidesToShow: 1,
        touchMove: false,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 6000,
        pauseOnHover: false,
        cssEase: 'linear',
        },
      },
    ],
  });
